import script from "./editGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./editGroup.vue?vue&type=script&lang=ts&setup=true"

import "./editGroup.vue?vue&type=style&index=0&id=e1b2e8b8&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1b2e8b8"]])

export default __exports__